<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px; padding-bottom:20px;">About the Author</h1>
<p>The author, Stanislas M. Yassukovich, was born in Paris to a Russian émigré father and a French mother. After being educated in the United States, he settled in England, pursued a career in the City of London and is regarded as one of the founders of the international capital market. He was made a Commander of the British Empire and is a Fellow of the Royal Society of Arts and a Freeman of the City of London. His previous works, <em>Two Lives: A Social and Financial Memoir, Lives of the</em> <em>Luberon</em> and <em>James Grant</em> were published by Austin Macauley in 2016 and 2020. He is married to the former Diana Townsend and has three children, Tatyana, Michael and Nicholas.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6674899d